import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router";
import { createStructuredSelector } from "reselect";
import socket from "../../assets/socketConnection";
// import Map from "leaflet";
import { MenueButton } from "./newReq.styles";
import { Link } from "react-router-dom";
import HomeIcn from "../../assets/img/img_home.svg";
import MapCustom from "../../containers/MapCustom/MapCustom.component";
import SubmitReq from "../../containers/submitReq/submitReq.component";
import { selectMapLevel } from "../../redux/map/map.selectors";
import {
  fetchDaysAheadAsync,
  fetchLoadTypesAsync,
  fetchNewRequestCitiesAsync,
  fetchNewRequestVehiclesAsync,
} from "../../redux/newRequest/newRequest.actions";
// import WithMainContainer from "../../HOC/withMainContainer/WithMainContainer.HOC";

// const SumbitReqWithMainContainer = WithMainContainer(SubmitReq);

const NewReq = ({
  selectMapLevel,
  fetchNewRequestCitiesAsync,
  fetchNewRequestVehiclesAsync,

  fetchLoadTypesAsync,
  fetchDaysAheadAsync,
}) => {
  const params = useParams();

  useEffect(() => {
    if (params.id) {
      return;
    }
    fetchNewRequestCitiesAsync(socket);
    // fetchNewRequestVehiclesAsync(socket);
    fetchLoadTypesAsync(socket);
    fetchDaysAheadAsync(socket);

    // return () => {
    //   cleanup
    // }
  }, []);
  if (selectMapLevel <= 3) {
    return (
      <>
        <div className="w-100 h-100 p-0 shadow">
          <MenueButton
            right={["/app2/vehicle-category", "/app2/new-req"].includes(
              window.location.pathname
            )}
          >
            <Link className="d-flex" to="/app2/home">
              <img src={HomeIcn} alt="img"></img>
            </Link>
          </MenueButton>
          <MapCustom />
        </div>
      </>
    );
  }
  if (selectMapLevel === 4) {
    return <SubmitReq />;
  }

  // return (
  //   <>
  //     {selectMapLevel <= 3 ? (
  //       <div className="w-100 h-100 p-0 shadow">
  //         <MapCustom />
  //       </div>
  //     ) : (
  //       <SubmitReq />
  //     )}
  //   </>
  // );
};

const mapStateToProps = createStructuredSelector({
  selectMapLevel: selectMapLevel,
});

const mapDisptachToProps = (dispatch) => ({
  fetchNewRequestCitiesAsync: (x) => dispatch(fetchNewRequestCitiesAsync(x)),
  // fetchNewRequestVehiclesAsync: (x) =>
  //   dispatch(fetchNewRequestVehiclesAsync(x)),
  fetchLoadTypesAsync: (x) => dispatch(fetchLoadTypesAsync(x)),
  fetchDaysAheadAsync: (x) => dispatch(fetchDaysAheadAsync(x)),
});

export default connect(mapStateToProps, mapDisptachToProps)(NewReq);
